// GA4 ids from gtag cookies → backend sends the server-side `purchase` attributed to this user/session.
const GA4_ID = "G-C6TQVE2147";

const cookie = (name) => document.cookie.split("; ").find((c) => c.startsWith(name + "="))?.slice(name.length + 1) || "";

export const getGaIds = () => {
  const ga = cookie("_ga"); // GA1.1.<cid1>.<cid2>
  const parts = ga.split(".");
  const client_id = parts.length >= 4 ? `${parts[2]}.${parts[3]}` : "";
  const sess = cookie(`_ga_${GA4_ID.replace("G-", "")}`); // GS1.1.<sid>.<n>… or GS2.1.s<sid>$o<n>…
  const m = sess.match(/^GS\d\.\d\.s?(\d{9,11})/);
  const session_id = m ? m[1] : "";
  return client_id ? { client_id, session_id } : null;
};

export const GA_ITEM = { item_id: "M2S-CLEANER-1P3F", item_name: "make2shine Multifunctional Japanese Cleaner (Buy 1 Get 3 FREE)", item_brand: "make2shine", item_category: "Home Cleaning", quantity: 1 };

// Browser funnel events (no PII). `purchase` is server-side only — never call it here.
export const gaEvent = (name, params) => {
  try {
    if (typeof window.gtag === "function") window.gtag("event", name, params);
  } catch (_) { /* tracking must never break checkout */ }
};

export const gaFunnel = (name, value, extra = {}) =>
  gaEvent(name, { currency: "INR", value, items: [{ ...GA_ITEM, price: value }], ...extra });
